import React, { useEffect, useState } from "react";

import "./mainDashboard.css";
import styles from './mainDashboard.module.css';

// 메인대시보드
const MainDashboard = ({ conn }) => {


  return (
    <>
      <div className={styles.container}>
        <div className={styles.leftSide}>
          <div className={styles.managementState}>
            <img className={styles.managementStateImg} src="/images/management3.png" alt="관리현황"/>
            <text className={styles.managementText}>관리 현황</text>
          </div>
          <div className={styles.safeBoxState}>
            안심박스 현황 <text className={styles.safeBoxStateValue}>70</text>
          </div>
          <button className={styles.emergencyBtn}>
            <img className={styles.emergencyImg} src="/images/emergency.png" alt="응급"/>
            응급 현황 &nbsp;&nbsp; 7
          </button>
          <button className={styles.aicallBtn}>
            <img className={styles.aicallImg} src="/images/aicall.png" alt="aicall"/>
            AI콜 현황 &nbsp;&nbsp; 5
          </button>
        </div>
        <div className={styles.rightSide}>
          <div className={styles.insideBox}>
            <div className={styles.insideBoxLeft}>
              <div className={styles.insideBoxLeftTop}>
                <img className={styles.inImg} src="/images/in3.png" alt="재실"/>
                <text className={styles.inText}>재실<b style={{marginLeft: "1vw", color:"#348134"}}>52</b></text>
                <text className={styles.highAcitivityText}>고활동</text>
                <img className={styles.highActivityImg} src="/images/highActivity.png" alt="외출"/>
              </div>
              <div className={styles.insideBoxLeftBottom}>
                <div className={styles.box}>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      청소
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>7</text>명
                    </div>
                  </div>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      운동
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>3</text>명
                    </div>
                  </div>
                </div>
                <div className={styles.box}>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      빨래
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>1</text>명
                    </div>
                  </div>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      기타
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>5</text>명
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.insideBoxRight}>
              <div className={styles.insideBoxRightTop}>
                <img className={styles.lowActivityImg} src="/images/lowActivity.png" alt="안심존내"/>
              </div>
              <div className={styles.insideBoxRightBottom}>
                <div className={styles.box}>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      TV시청
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>11</text>명
                    </div>
                  </div>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      수면
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>6</text>명
                    </div>
                  </div>
                </div>
                <div className={styles.box}>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      식사
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>5</text>명
                    </div>
                  </div>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      기타
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>12</text>명
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.outsideBox}>
            <div className={styles.outsideBoxLeft}>
              <div className={styles.outsideBoxLeftTop}>
                <img className={styles.outImg} src="/images/out3.png" alt="외출"/>
                <text className={styles.outText}>외출<b style={{marginLeft: "1vw", color:"#348134"}}>32</b></text>
                <img className={styles.highActivityImg} src="/images/safeIn.png" alt="안심존내"/>
              </div>
              <div className={styles.outsideBoxLeftBottom}>
                <div className={styles.box}>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      마을회관
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>4</text>명
                    </div>
                  </div>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      마실
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>4</text>명
                    </div>
                  </div>
                </div>
                <div className={styles.box}>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      병원
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>3</text>명
                    </div>
                  </div>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      기타
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>1</text>명
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.outsideBoxRight}>
              <div className={styles.outsideBoxRightTop}>
                <img className={styles.lowActivityImg} src="/images/safeOut.png" alt="안심존내"/>
              </div>
              <div className={styles.outsideBoxRightBottom}>
                <div className={styles.box}>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      병원
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>15</text>명
                    </div>
                  </div>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      종교활동
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>11</text>명
                    </div>
                  </div>
                </div>
                <div className={styles.box}>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      여행
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>5</text>명
                    </div>
                  </div>
                  <div className={styles.boxData}>
                    <div className={styles.boxDataTitle}>
                      기타
                    </div>
                    <div className={styles.boxDataValue}>
                      <text className={styles.value}>9</text>명
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainDashboard;
